
import React, {  useState, useEffect  } from 'react';

import {Avatar, Drawer,Space,Card,Table,Image,Tabs,Spin,List,Button,Tooltip, Tag, message,Col, Row,Badge,Divider,Descriptions,Modal,Popover} from 'antd';
// import ReactJson from 'react-json-view';
import { JsonToTable } from "react-json-to-table";


import {
    ReconciliationOutlined,
    CloudDownloadOutlined,
    SyncOutlined,
    PictureOutlined,
    CheckCircleOutlined,
    IssuesCloseOutlined,
    CloseOutlined,
    BarChartOutlined,
    FileProtectOutlined,
    SolutionOutlined,
    LoadingOutlined,
    FullscreenOutlined,
    FullscreenExitOutlined,
    FileSearchOutlined,
    DeleteOutlined,
    ExclamationCircleFilled,
    FileDoneOutlined,
  } from '@ant-design/icons';


import {getRunDetails,getUserDetail,getRunFiles,getRunDetailsExtra,deleteActivityAPI,API_BASE,downloadEX,getJsonFile} from './../../services';


const { confirm } = Modal;

const authRole =
  ["admin"].indexOf(localStorage.getItem("is_role")) !== -1 ? true : false;

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

  
const columns = [
    {
        title: '#ID',
        dataIndex: 'id',
        key: 'id',
        render: (text) => <a>{text}</a>,
      },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    render: (text) => <a>{text}</a>,
  },
  {
    title: 'Place',
    dataIndex: 'place',
    key: 'place',
  },
   {
    title: 'Validated Intervals',
    dataIndex: 'validated_intervals',
    key: 'validated_intervals',
  },
  // {
  //   title: 'Status',
  //   dataIndex: 'status',
  //   key: 'status',
  // },
  {
    title: 'Action',
    key: 'action',
    dataIndex:'action'
  },
];


const DetailView = (props) => {
  const [open, setOpen] = useState(true);
  const [childrenDrawer, setChildrenDrawer] = useState(false);
  const [userRunList, setUserRunList] = useState([]);
  const [DetailLoader, setDetailLoader] = useState(false);
  
  const [viewRunInfo, setviewRunInfo] = useState({});
  const [viewRunTitle, setRunTitle] = useState({});
  const [userFiles, setuserFiles] = useState([]);
  const [currentActivity, setActivity] = useState([]);
  const [visible, setVisible] = useState(false);
  const [fullscreen, setFullscreen] = useState(false);

  const [dbviewDrawer,setDbviewDrawer] = useState(false);


//   GET RUN DETAILS:

 
// const getUserRunDetails =  async(thisUID) =>{
//     return  await getUserDetail(thisUID);    
// }



 const viewRunDB  = async(_record) => {
    console.log(_record);

    setActivity(_record);

    setDetailLoader(true);
    message.loading({
        content: 'Fetching Records...',
        key:'view_run'
    },0);


    // message.loading({
    //     content: 'Please Wait...',
    //     key:'view_run'
    // },0);
    const {data,status}   = await getRunDetailsExtra(_record);


    message.loading({
        content: 'Fetching Files...',
        key:'view_run'
    });

  
    setDetailLoader(false);
    if(status=='success'){
        setRunTitle("#"+_record.run_id+" - Run Details");
        setviewRunInfo(data);
        message.success({
            content: 'Data load complete.',
            key:'view_run',
            duration: 2,
        });
         setDbviewDrawer(true);
    } else {
        message.error({
            content: 'Data load incomplete.',
            key:'view_run',
            duration: 2,
        });
    }

    
};

const getValidatedInfo = (thisInfo) =>{

  let thisData  = Object.keys(thisInfo|| {}).length > 0 ? JSON.parse(thisInfo) : [];

  // console.log(thisData);

  return thisData;

}

    const userRunsMake = (thisRunObj) => {
        let currentRunObj = [];

        thisRunObj.forEach((element,index) => {
            
            currentRunObj.push({
                key: index,
                id: element.run_id,
                date: element?.run_info?.date,
                place: element?.run_info?.place,
                validated_intervals: (
                  <Popover
      content={<div className="validated_intervals_popup"><ul>{
        element.validated_intervals && JSON.parse(element.validated_intervals|| []).map((vint,index)=><li>{vint}</li>) || <div> EMPTY </div>
      } </ul>

      </div>}
      title="Validated Intervals"
      trigger="click"
      
    >
    {(getValidatedInfo(element.validated_intervals).length == element.no_of_intervals ? 
      <Tag icon={<CheckCircleOutlined />} color="success">
                Validated  |  ( {getValidatedInfo(element.validated_intervals).length+" / "+element.no_of_intervals } )
              </Tag> : 
              <Tag icon={<CheckCircleOutlined />} color="warning">
                On Process  |  ( {getValidatedInfo(element.validated_intervals).length+" / "+element.no_of_intervals } )
              </Tag>)}
       
    </Popover>),
                action:(
                    <Space size="middle">
                       
                       <Tooltip title="View Run Details"><Button type="primary" onClick={()=>viewRun(element)}  shape="circle" size='large' icon={<ReconciliationOutlined />} /> </Tooltip>
                       <Tooltip title="Download Rotated CSV"><Button onClick={()=>downloadFile(element.file_path,'server')} type="primary" shape="circle" size='large' icon={<CloudDownloadOutlined />} /></Tooltip>

                       {authRole ?
                       <Tooltip title="DB Records"><Button style={{ color: "red", border:"2px solid"}} onClick={()=>viewRunDB(element)}  type="info" shape="circle" size='large' icon={<FileSearchOutlined />} /></Tooltip>: "" }

                       {authRole ?         <Tooltip title="Download JSON File"><Button onClick={()=>downloadJson(element)} style={{ color: "green", border:"2px solid"}} shape="circle" size='large' icon={<FileDoneOutlined />} /></Tooltip> : ""}

                  </Space>
                )
                
              });
        });

        setUserRunList(currentRunObj);
    }

  useEffect(async () => {
    // console.log(open);
    console.log("USER ALL RUNS:");
    // console.log(props);
    userRunsMake(props.props.run_list);
    // const thisData  = await getUserDetail(props.props);

    // const {status,message} = thisData;
    // if(status=="success"){

    //     userRunsMake(message);
    //     // setUserRunList(message);
    //     // console.log(userRunList);
    // }

    
    // 
    
    
}, []); 




const syncRuns  = async () => {


let thisMessage = message;
    thisMessage.loading({
      content: "Loading...",
      key: "all_runs",
    });

    const thisData = await getUserDetail(props.props);
    const { status } = thisData;

    if (status) {
     

      userRunsMake(thisData.message);
      thisMessage.success({
        content: "Loaded!",
        key: "all_runs",
        duration: 2,
      });
    } else {
      thisMessage.error({
        content: "Not Loaded!",
        key: "all_runs",
        duration: 2,
      });
    }


}

const downloadJson = async (downloadUrl) => {
  const jsonFile = await getJsonFile(downloadUrl);

  if(jsonFile.status){
    // downloadEX(jsonFile.data);
   const fileName = downloadUrl.id;
  const json = JSON.stringify(jsonFile.data, null, 2);
  const blob = new Blob([json], { type: "application/json" });
  const href = URL.createObjectURL(blob);

  // create "a" HTLM element with href to file
  const link = document.createElement("a");
  link.href = href;
  link.download = fileName + ".json";
  document.body.appendChild(link);
  link.click();

  // clean up "a" element & remove ObjectURL
  document.body.removeChild(link);
  URL.revokeObjectURL(href);

  }
  
}

   const downloadFile  = async (downloadUrl,_type) => {

    // console.log(downloadUrl,_type);

    let DownloadLink = " ";
    if(_type=="server"){
        downloadUrl = downloadUrl.replace("/home/ec2-user/NodeApi/public",API_BASE);


        // console.log(downloadUrl);
        DownloadLink = downloadUrl;
    } else {

        DownloadLink = downloadUrl;
    }
      // downloadEX(DownloadLink);



    DownloadLink = DownloadLink.replace("pdviewer.projectdasein.com/","");
    console.log(DownloadLink);

     downloadEX(DownloadLink);
    

    

//     let downloadOptions = {
//     url: DownloadLink,
//     filename: DownloadLink.split('/').pop(),
// }

    // new JsFileDownloader({url: DownloadLink,responseType: 'blob'})
    // .then(function() {
    //     console.log('download finished!')
    // })


    // new JsFileDownloader({ 
    //   url: DownloadLink,
    //   contentTypeDetermination:"full",
    //   forceDesktopMode: true
    // });

    // fileDownload(data, 'filename.csv');

    // const link = document.createElement('a');
    // link.href = DownloadLink;
    // // link.target="_blank";
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);

    
  };


  const deleteActivity = async (_record) =>{

    confirm({
    title: 'Do you Want to delete these activity?',
    icon: <ExclamationCircleFilled />,
    onOk:async() => {

      const {data,status}   = await deleteActivityAPI(_record);
        if(status){
          setDbviewDrawer(false);
          syncRuns();
        }
    },
    onCancel() {
      
    },
  });
     

  }
   

  const viewRun  = async(_record) => {
    console.log(_record);

    setActivity(_record);

    setDetailLoader(true);
    message.loading({
        content: 'Fetching Records...',
        key:'view_run'
    },0);


    // message.loading({
    //     content: 'Please Wait...',
    //     key:'view_run'
    // },0);
    const {data,status}   = await getRunDetails(_record);


    message.loading({
        content: 'Fetching Files...',
        key:'view_run'
    });

    let thisFileData   = await getRunFiles(_record);
    thisFileData = Object.entries(thisFileData.message);  

    setuserFiles(thisFileData);
    console.log(thisFileData);

    setDetailLoader(false);
    if(status=='success'){
        setRunTitle("#"+_record.run_id+" - Run Details");
        setviewRunInfo(data);
        message.success({
            content: 'Data load complete.',
            key:'view_run',
            duration: 2,
        });
        setChildrenDrawer(true);
    } else {
        message.error({
            content: 'Data load incomplete.',
            key:'view_run',
            duration: 2,
        });
    }

    
};
 
 

// const  filterValuePart=(arr, part) =>{
//     return arr.filter(function(obj) {
//         return Object.keys(obj)
//                      .some(function(k) { 
//                         console.log(typeof obj[k]);
//                         if(typeof obj[k] =="string"){
//                                return obj[k].toString.indexOf(part) !== -1; 
//                             }
//                            });
//     });
// }

// const onSearch = (e) =>{
//     const {value} = e.target;
//     console.log(value);
//     console.log(props.props);

//     let {run_list}  = props.props;

//     console.log(run_list)
    
    
//     const filterResponse =  filterValuePart(run_list,value);

//     // console.log(filterResponse);


//     // run_list = run_list.filter((userItem)=> {

//     //     console.log(typeof userItem.run_id );

//     //     if(typeof userItem.run_id !=="number"){
//     //         return userItem.run_id.indexOf(value) !== -1;
//     //     }
//     //     // console.log( userItem.id, userItem.run_id);
//     //     // return  !=='undefined' ? userItem.run_id.indexOf(value)!==-1 : userItem;
//     // });

//     // console.log(run_list);

    

//     userRunsMake(filterResponse);
// }

const replaceLRString=(string,selector) =>{

if(selector==="action_detector_images"){

        string = string.split(",");

        string = <Descriptions layout='horizontal' style={{maxHeight:"250px",overflow:"auto"}} bordered>{string.map((item,index)=> 

        
          <Descriptions.Item labelStyle={{width:'15%'}} style={{textAlign:"center"}} span={3} label={(index+1)}>
           
             <Image src={`data:image/jpeg;base64,`+item} />
          </Descriptions.Item>

          )}
        </Descriptions>;


} else{

      if(typeof(string)=="string"){

        string  = JSON.parse(string);

        string =   <Descriptions layout='horizontal' style={{maxHeight:"250px",overflow:"auto"}} bordered>{string.map((item,index)=> 
          <Descriptions.Item labelStyle={{width:'15%'}} span={3} label={(index+1)}>{item.join(',')}</Descriptions.Item>
          )}
        </Descriptions>;

      } else {



        string =   <Descriptions layout='horizontal' style={{maxHeight:"250px",overflow:"auto"}} bordered >{string.map((item,index)=> 
          <Descriptions.Item labelStyle={{width:'15%'}} span={3} label={(index+1)}>{item.join(',').replaceAll('0','R').replaceAll('1','L')}</Descriptions.Item>
          )}
        </Descriptions>;

      }

  }

  



  return string;
};



 const randomIntFromInterval=(min, max)=> { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min)
  }

const thisSyncRuns = () =>{
    // console.log("sync");

    syncRuns();
}


  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
    props.onCloseParent(false);
  };
  const showChildrenDrawer = () => {
    setChildrenDrawer(true);
  };
  const onChildrenDrawerClose = () => {
    setChildrenDrawer(false);
      setDbviewDrawer(false);
  };

  const enLarge = () =>{

    const thisState  = (fullscreen ?  false : true);

    setFullscreen(thisState);
  }
  console.log(props.props);

  console.log(currentActivity);


const thisUrlEncorder=(thisCntext)=> {

  return encodeURIComponent(JSON.stringify(Object.values(thisCntext|| [])));
}

const getValidatedParam = (thisInfo) =>{

  let thisData  = Object.keys(thisInfo|| {}).length > 0 ? JSON.parse(thisInfo) : [];



  return thisData;

}


  const  {name,id}  =props.props;

   const thisMlAppUrl= `https://ml.projectdasein.com/?raw_data=${encodeURIComponent(API_BASE)}/uploads/${currentActivity.user_id}/rawdata/${currentActivity.id}.csv&interval_notes="${thisUrlEncorder(viewRunInfo.interval_notes)}&username=${(name ? name.replace(/ /g,'') : "" )}&run_id=${currentActivity.run_id}&activity_id=${currentActivity.id}`;
   
  // const thisMlAppUrl= `https://ml.projectdasein.com/?raw_data=${encodeURIComponent('http://54.191.51.72:8888')}/uploads/${currentActivity.user_id}/rawdata/${currentActivity.id}.csv&interval_notes="${encodeURIComponent(JSON.stringify(Object.values(viewRunInfo.interval_notes|| [])))}`;

  return (
    <>
     
      <Drawer className="settings-drawer"
            mask={true}
            width={1024}
            onClose={onClose}
            placement={"right"}
            visible={open}  title={name+" -  All Runs"} closeIcon={( DetailLoader ? <Spin  /> : <CloseOutlined />)}>
        

        {/* ALL RUNS LIST */}
        <Card  >
        <Button
        onClick={thisSyncRuns}
        type="primary"
        style={{
          marginBottom: 16,
        }}
        icon={<SyncOutlined/>}
      >
        Sync Latest Runs
      </Button>

        <Table columns={columns} dataSource={userRunList} />
        </Card>
        {/* ALL RUNS LIST */}




        {/* 2nd LEVEL  DETAILS */}


      {dbviewDrawer ? 
        <Drawer
          className="settings-drawer pd_activity_view"
          mask={true}
          width={920}
          onClose={onChildrenDrawerClose}
          placement={"right"}
          visible={dbviewDrawer}  
          title={viewRunTitle}
          
        >

       <JsonToTable json={viewRunInfo} /> 
       <Divider orientation="left">Delete  Run Activity</Divider>

        <Space direction="vertical" style={{ width: '100%' }}>
    <Button icon={<DeleteOutlined />}  onClick={()=>deleteActivity(viewRunInfo)}  type="danger" block>
      Delete
    </Button>

    </Space>
        </Drawer> : ""

        } 

{childrenDrawer &&
  viewRunInfo && Object.keys(viewRunInfo).length ? 

        <Drawer
          className="settings-drawer pd_activity_view"
          mask={true}
          width={920}
          onClose={onChildrenDrawerClose}
          placement={"right"}
          visible={childrenDrawer}  title={viewRunTitle}
          
          
        >


<Tabs defaultActiveKey="1">
    <Tabs.TabPane   tab={<span><BarChartOutlined/> Metrics Data</span>} key="1">
    
    <Divider orientation="left">Force Portrait</Divider>

    <Card className='fp_view_block'  >
    <Row>
        {/* FP LIST */}
        <Image.PreviewGroup
         
        >
        {
          ['rearview','sideview','topview'].map((view)=>
          <Col span={8} className='text-center'>
     
          <Image
          width={200}
          src={API_BASE+'/default_views/'+id+'/img/'+currentActivity.id+'_'+view+'.jpg'}
        />
        <Tag icon={<PictureOutlined />} color="processing">
        {view}
      </Tag>
        </Col>
          )
        }
        </Image.PreviewGroup>



    </Row>

    
</Card>

{viewRunInfo.route_map_images  &&  viewRunInfo.route_map_images.length ?
<>
    <Divider orientation="left">Route Map Image</Divider>

    <Card className='fp_view_block'  >
    <Row>
        {/* FP LIST */}
        <Image.PreviewGroup
         
        >
        {
          viewRunInfo.route_map_images && viewRunInfo.route_map_images.map((route_map_url)=>
          <Col span={8} className='text-center'>
     
          <Image
          width={150}
          src={route_map_url}
        />
        </Col>
          )
        }
        </Image.PreviewGroup>



    </Row>

    
</Card></> : "" }

<Divider orientation="left">Run Session Data</Divider>

<Descriptions   bordered>

<Descriptions.Item label="Workout Notes" span={3}>
    {viewRunInfo.survey_info.workout_log||' - '}
    </Descriptions.Item>

    <Descriptions.Item label={`Interval Notes (${viewRunInfo.interval_notes.length || []})`} span={3}>
    <Descriptions  bordered size='small' style={{maxHeight:"250px",overflow:"auto"}}>
      { 
        Object.entries(viewRunInfo.interval_notes).map((notes)=>
        <Descriptions.Item labelStyle={{width:'25%', textTransform:'capitalize'}} label={(parseInt(notes[0])+1)} span={4}>{
          notes[1]
          }</Descriptions.Item>
        )
      }

    </Descriptions>
    </Descriptions.Item>

    <Descriptions.Item labelStyle={{width:'20%', textTransform:'capitalize'}} label="Place" span={3}>{viewRunInfo.run_info.place}</Descriptions.Item>
    <Descriptions.Item label="Date" span={3}>{viewRunInfo.run_info.date}</Descriptions.Item>
    <Descriptions.Item label="Timing" >{viewRunInfo.run_info.timing}</Descriptions.Item>



    
    {/* <Descriptions.Item label="Time" >{viewRunInfo.run_info.time}</Descriptions.Item> */}
    <Descriptions.Item label="Laps" >{viewRunInfo.run_info.laps}</Descriptions.Item>
    <Descriptions.Item label="Distance" >{viewRunInfo.run_info.distance}</Descriptions.Item>


    <Descriptions.Item label="Run Mode" >{viewRunInfo.RunMode || '-'}</Descriptions.Item>
    <Descriptions.Item label="SessionType" >{viewRunInfo.SessionType||'-'}</Descriptions.Item>
    <Descriptions.Item label="TerrainType" >{viewRunInfo.TerrainType||'-'}</Descriptions.Item>


    <Descriptions.Item label="ML Version" span={3}><Tag size="small" icon={<FileProtectOutlined />} color="lime">
            {viewRunInfo.ml_version||'v.0.0'}
             </Tag></Descriptions.Item>
    

    { /*<Descriptions.Item label="Interval Actions" span={3}>{viewRunInfo.interval_actions || '-'}</Descriptions.Item> */}
             

    <Descriptions.Item label="Metrics" span={3}>
    <Descriptions  bordered size='small' >
      {
        Object.entries(viewRunInfo.Metrics).map((metrics)=>
        <Descriptions.Item labelStyle={{width:'25%', textTransform:'capitalize'}} label={metrics[0]} span={4}>{
          
            (["Rawpeakslist","leftright_array","action_detector_images"].indexOf(metrics[0])!==-1  ? replaceLRString(metrics[1],metrics[0]) : metrics[1] )

          }</Descriptions.Item>
        )
      }

    </Descriptions>
    </Descriptions.Item>




    <Descriptions.Item label="Preferred Metric Order" span={3}>
    {viewRunInfo.preferred_metric_order||' - '}
    </Descriptions.Item>

    <Descriptions.Item label="Coach notes" span={3}>
    {viewRunInfo.coach_notes||' - '}
    </Descriptions.Item>

    <Descriptions.Item label="Status" span={3}>
      {currentActivity.status ? <Badge status="success" text="Completed" />: <Badge status="error" text="In Completed" /> }
      
    </Descriptions.Item>
   
  </Descriptions>


{/* 
    <Tabs defaultActiveKey="1" tabPosition="left">
    <Tabs.TabPane tab="Tab 1" key="1">
      Content of Tab Pane 1
    </Tabs.TabPane>
    <Tabs.TabPane tab="Tab 2" key="2">
      Content of Tab Pane 2
    </Tabs.TabPane>
    <Tabs.TabPane tab="Tab 3" key="3">
      Content of Tab Pane 3
    </Tabs.TabPane>
  </Tabs> 

  <ReactJson src={viewRunInfo} collapsed={1} displayDataTypes={false}  />*/}

    </Tabs.TabPane>
    <Tabs.TabPane tab={<span><FileProtectOutlined/> Files</span>} key="2">
      
      
    <List
      size="small"
      header={<div>{viewRunTitle+" - File Downloads"} </div>}
      
      
      dataSource={userFiles}
      renderItem={item => {

        let thisLink = item[1];
        const ColorList = ['#f56a00', '#7265e6', '#ffbf00', '#00a2ae'];
              if(item[0]==="leftright_array"){
                  thisLink  = thisLink.replace(".csv",".json");
              }

        const linkDesc = thisLink.replace("/home/ec2-user/NodeApi/public",API_BASE);

        return (<List.Item key={item[0]}>
            <List.Item.Meta
              avatar={<Avatar  
                size={40}
              style={{
                backgroundColor: ColorList[randomIntFromInterval(0, 3)],
                verticalAlign: 'middle',
                textTransform:'capitalize'
              }} >{item[0][0]}</Avatar>}
              title={item[0]}
              description={linkDesc}
            />
            <div> <Button type="primary" onClick={()=>{
      
              downloadFile(thisLink,'server');
      
            }} shape="round" icon={<CloudDownloadOutlined />} size={"slarge"}> Download</Button>
       </div>
          </List.Item>);
      }
    }
    />
    </Tabs.TabPane>

  <Tabs.TabPane tab={<span><FileProtectOutlined/> ML VIEW</span>} key="3">
  



<div  className={(fullscreen ? "ml_container" : "" )}>  
<Card size="small" style={{width: "100%"}} title={<a href={thisMlAppUrl} target="_blank">{thisMlAppUrl}</a>} extra={<Tooltip title="Full Screen">
      <Button onClick={enLarge} type="primary"  shape="circle" size='large' icon={(fullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />) }  />
    </Tooltip>} >
  <iframe
        // src={"http://pdmlprediction-env.eba-7jfhm8xz.us-west-2.elasticbeanstalk.com"}
        
        src={thisMlAppUrl}

        onLoad={() => console.log("iframe loaded")}
        width="100%"
        height="900px"
        style={{border:"none"}}
      ></iframe> 
   </Card>   
   </div>

    {/*<div ><JsonToTable json={viewRunInfo} /> </div> */}


    </Tabs.TabPane>

    
   
  </Tabs>
</Drawer>:  " " } 


      </Drawer>
    </>
  );
};




export default DetailView;